import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import OverlayLoader from "../components/common/OverlayLoader";

// HOC to check if user is not logged in and redirect to home page if logged in
// for example used in login page to redirect to home page if user is logged in
const withNoAuth = (WrappedComponent) => {
  const withNoAuth = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const currentUser = useSelector((state) => state?.currentUser?.currentUser);
    const currentUserIsLoading = useSelector(
      (state) => state?.currentUser?.currentUserIsLoading
    );
    const router = useRouter();
    const isLoggedIn = !currentUserIsLoading && currentUser?.id ? true : false; // true if user is logged in, false if user is not logged in

    useEffect(() => {
      if (!currentUserIsLoading) {
        setIsLoading(isLoggedIn ? true : false); // same logic as withAuth HOC, just inverted
        // if user is logged in, redirect to the home page
        if (isLoggedIn) {
          router.push("/");
        }
      }
    }, [currentUserIsLoading]);

    return isLoading ? <OverlayLoader /> : <WrappedComponent {...props} />;
  };

  return withNoAuth;
};

export default withNoAuth;
